<a href="#sortCol" (click)="onSortClick($event)">
  <ng-content />
  <span *ngIf="sortingAsc">&#x25B2;</span> <span *ngIf="sortingDesc">&#x25BC;</span>
</a>
